var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "refund-audit" },
    [
      _c("public-title", {
        attrs: { serviceOrderId: _vm.serviceOrderId, active: _vm.active }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "refund-audit-content" }, [
        _c("div", { staticClass: "refund-audit-title" }, [
          _vm.serviceOrderStatus === 1
            ? _c("div", [
                _vm._v("\n          Please review the Service Order\n        ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceOrderStatus === 3
            ? _c("div", [
                _vm._v(
                  "\n          Retail has initiated arbitration, you can submit arbitration information\n          "
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#262B2F", margin: "0px 10px" } },
                  [_vm._v("Countdown")]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#FF4812", margin: "0px 5px" } },
                  [_vm._v(_vm._s(_vm.countDown.time))]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#262B2F", margin: "0px 5px" } },
                  [_vm._v("Days")]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#FF4812", margin: "0px 5px" } },
                  [_vm._v(_vm._s(_vm.countDown.hour))]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#262B2F", margin: "0px 5px" } },
                  [_vm._v("HRS")]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#FF4812", margin: "0px 5px" } },
                  [_vm._v(_vm._s(_vm.countDown.minute))]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#262B2F", margin: "0px 5px" } },
                  [_vm._v("MIN")]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#FF4812", margin: "0px 5px" } },
                  [_vm._v(_vm._s(_vm.countDown.second))]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#262B2F", margin: "0px 5px" } },
                  [_vm._v("SEC")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceOrderStatus === 60 || _vm.serviceOrderStatus === 61
            ? _c("div", { staticStyle: { color: "#FF4812" } }, [
                _vm._v(
                  "\n          You have rejected the after sale application, waiting for the buyer to modify the after sale application\n          "
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#262B2F", margin: "0px 10px" } },
                  [_vm._v("Countdown")]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#FF4812", margin: "0px 5px" } },
                  [_vm._v(_vm._s(_vm.countDown.time))]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#262B2F", margin: "0px 5px" } },
                  [_vm._v("Days")]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#FF4812", margin: "0px 5px" } },
                  [_vm._v(_vm._s(_vm.countDown.hour))]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#262B2F", margin: "0px 5px" } },
                  [_vm._v("HRS")]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#FF4812", margin: "0px 5px" } },
                  [_vm._v(_vm._s(_vm.countDown.minute))]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#262B2F", margin: "0px 5px" } },
                  [_vm._v("MIN")]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#FF4812", margin: "0px 5px" } },
                  [_vm._v(_vm._s(_vm.countDown.second))]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#262B2F", margin: "0px 5px" } },
                  [_vm._v("SEC")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceOrderStatus === 2
            ? _c("div", [
                _vm._v(
                  "\n          The Service Order has been approved and the refund is pending\n        "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceOrderStatus === 4
            ? _c("div", [_vm._v("\n          Refund successfully\n        ")])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceOrderStatus === 5
            ? _c("div", [
                _vm._v("\n          After sales order closed\n        ")
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.serviceOrderStatus === 1
          ? _c("div", { staticClass: "refund-audit-status" }, [
              _c("div", { staticClass: "refund-audit-status-content ash" }, [
                _c("div", [
                  _vm._v(
                    "Please process the approval order within 1-3 working days!"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "If agreed, the platform will refund directly to the retailer"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "If you disagree with the refund, you can negotiate with the retailer to revise the refund and re-initiate"
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "audit-status-edit" }, [
                  _c(
                    "div",
                    {
                      staticClass: "audit-status-edit-button",
                      on: {
                        click: function($event) {
                          return _vm.showReviewDialog(true)
                        }
                      }
                    },
                    [_vm._v("Agree to refund")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "audit-status-edit-button-refund",
                      on: {
                        click: function($event) {
                          return _vm.showReviewDialog(false)
                        }
                      }
                    },
                    [_vm._v("Refusing a refund")]
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.serviceOrderStatus === 3
          ? _c("div", { staticClass: "refund-audit-status" }, [
              _c("div", { staticClass: "refund-audit-status-content ash" }, [
                _c("div", [
                  _vm._v("Complete the upload of proof materials within 3 days")
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "After the voucher is uploaded, the platform will process it within 1-3 working days, please wait patiently"
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "audit-status-edit" }, [
                  _c(
                    "div",
                    {
                      staticClass: "audit-status-edit-button",
                      on: { click: _vm.showArbitrationVisible }
                    },
                    [_vm._v("Submission of Vouchers")]
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.serviceOrderStatus === 60 || _vm.serviceOrderStatus === 61
          ? _c("div", { staticClass: "refund-audit-status" }, [_vm._m(0)])
          : _vm._e(),
        _vm._v(" "),
        _vm.serviceOrderStatus === 2
          ? _c("div", { staticClass: "refund-audit-status" }, [_vm._m(1)])
          : _vm._e(),
        _vm._v(" "),
        _vm.serviceOrderStatus === 4
          ? _c("div", { staticClass: "refund-audit-status" }, [
              _c("div", { staticClass: "refund-audit-status-content" }, [
                _c("div", { staticClass: "refund-succeess-row" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("Refund Success Time")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.serviceOrder.createAt))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "refund-succeess-row" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("Refund Total")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "value" }, [
                    _vm._v(
                      "$" +
                        _vm._s(_vm.serviceOrder.refundTotalAmount.toFixed(2)) +
                        "  (" +
                        _vm._s(_vm.refundBear) +
                        " bear the cost of refunds)"
                    ),
                    _c("br")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "refund-succeess-row" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("Return Method")
                  ]),
                  _vm._v(" "),
                  _vm.payMethod === "5"
                    ? _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.payEmail) + "(PayPal Account)")
                      ])
                    : _vm.payMethod !== "1"
                    ? _c("div", { staticClass: "value" }, [
                        _vm._v(
                          "Bank account ending in " + _vm._s(_vm.cardLast4)
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.payMethod === "1"
                    ? _c("div", { staticClass: "value" }, [
                        _vm._v("Net terms:”Refund of Net terms Quota”")
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.payMethod !== "1"
                  ? _c("div", [
                      _vm._v(
                        "Your refund will be returned to the retailer account according to the original route, and it will take 3-5 working days for the refund to arrive."
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.payMethod === "1"
                  ? _c("div", [
                      _vm._v(
                        "For the order of using the net 60 term without repayment, you will not be charged a fee for returning products if they are in their original condition."
                      )
                    ])
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.serviceOrderStatus === 5
          ? _c("div", { staticClass: "refund-audit-status" }, [_vm._m(2)])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "refund-audit-history" },
          [
            _c("span", { staticClass: "medium history-title" }, [
              _vm._v(" Refund History")
            ]),
            _vm._v(" "),
            _vm._l(_vm.refundHistory, function(i, k) {
              return _c(
                "div",
                { key: k },
                [
                  i.status === 6 || i.status === 80
                    ? _c("after-sales", {
                        attrs: { message: i, status: i.status }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  i.status === 2 ||
                  i.status === 4 ||
                  i.status === 60 ||
                  i.status === 61 ||
                  i.status === 81
                    ? _c("approved", {
                        attrs: { message: i, status: i.status }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  i.status === 3 ||
                  i.status === 30 ||
                  i.status === 31 ||
                  i.status === 32 ||
                  i.status === 33
                    ? _c("arbitration", {
                        attrs: {
                          message: i,
                          status: i.status,
                          serviceOrderMessage: _vm.serviceOrder
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  i.status === 5 || i.status === 34
                    ? _c("close-after-sales", {
                        attrs: { serviceOrder: _vm.serviceOrder, message: i }
                      })
                    : _vm._e()
                ],
                1
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "refund-audit-details" },
          [
            _c("refund-details", {
              attrs: {
                serviceOrder: _vm.serviceOrder,
                orderInfo: _vm.orderInfo
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _vm.serviceOrderDetail.length > 0
              ? _c("commodity-list", {
                  attrs: {
                    edit: false,
                    titleType: true,
                    serviceOrderDetail: _vm.serviceOrderDetail
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("review-dialog", {
        attrs: {
          reviewVisible: _vm.reviewVisible,
          action: _vm.action,
          reason: _vm.reason
        },
        on: { back: _vm.back, reviewServiceOrder: _vm.reviewServiceOrder }
      }),
      _vm._v(" "),
      _c("arbitration-dialog", {
        attrs: {
          arbitrationVisible: _vm.arbitrationVisible,
          serviceOrderId: _vm.serviceOrderId
        },
        on: {
          backArbitrationVisible: _vm.backArbitrationVisible,
          loadData: _vm.loadData
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "refund-audit-status-content ash" }, [
      _c("div", [
        _vm._v(
          " The retailer can modify the order within 3 days, and re-initiate the after sale application, if the order has not been modified, the order is closed."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "refund-audit-status-content ash" }, [
      _c("div", [
        _vm._v(
          " The ShopVidi platform will process your application within 1-3 working days, please be patient!"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "refund-audit-status-content ash" }, [
      _c("div", [
        _vm._v(
          " The back order has been closed and the transaction will proceed normally."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76862834", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76862834","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/service-order/service-order-detail.vue
// module id = z3s5
// module chunks = 2